import LogManager from "./LogManager";

const STORAGE_KEY = "aims_verbosity_preference";

/**
 * Get the current user's verbosity preference.
 * Returns cached value if available, otherwise fetches from backend.
 * @returns {Promise<string>} verbosityLevel ("concise", "moderate", or "detailed")
 */
export const getPreference = async () => {
  const cached = sessionStorage.getItem(STORAGE_KEY);
  if (cached) return cached;

  try {
    const response = await fetch("/preferences", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "get" }),
    });

    if (!response.ok) {
      throw new Error(`/preferences GET failed with status ${response.status}`);
    }

    const responseJson = await response.json();
    const payload = JSON.parse(JSON.parse(responseJson.Payload));
    const level = payload.verbosityLevel || "concise";
    sessionStorage.setItem(STORAGE_KEY, level);
    return level;
  } catch (error) {
    LogManager.error("Error calling /preferences get:", error);
    return "concise";
  }
};

/**
 * Update the current user's verbosity preference.
 * Updates cache on success.
 * @param {string} verbosityLevel - "concise", "moderate", or "detailed"
 * @returns {Promise<string>} the confirmed verbosityLevel from the backend
 */
export const updatePreference = async (verbosityLevel) => {
  try {
    const response = await fetch("/preferences", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "update", verbosityLevel }),
    });

    if (!response.ok) {
      throw new Error(`/preferences UPDATE failed with status ${response.status}`);
    }

    const responseJson = await response.json();
    const payload = JSON.parse(JSON.parse(responseJson.Payload));
    const level = payload.verbosityLevel || verbosityLevel;
    sessionStorage.setItem(STORAGE_KEY, level);
    return level;
  } catch (error) {
    LogManager.error("Error calling /preferences update:", error);
    throw error;
  }
};
